var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("app-browse", {
        attrs: {
          "data-source": _vm.dataSource,
          "selected-items": _vm.selectedItems,
          "url-query-params": "",
          "button-bar-items": _vm.buttonBarItems,
        },
        on: {
          state: function ($event) {
            _vm.browseState = $event
          },
        },
      }),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/cars",
            "full-height": "",
            "escape-close": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              "car-saved": function ($event) {
                return _vm.updateView()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.uploadCSVModal,
            callback: function ($$v) {
              _vm.uploadCSVModal = $$v
            },
            expression: "uploadCSVModal",
          },
        },
        [
          _c("app-import-csv-modal", {
            on: {
              close: function ($event) {
                _vm.uploadCSVModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }